<template>
  <b-field v-if="items.length > 1" :label="label">
    <qd-taginput v-if="items"
                v-model="selected"
                :data="filteredItems"
                type="is-primary"
                icon="magnify"
                autocomplete
                open-on-focus
                field="libelleAgence"
                @typing="updateSearch">
    </qd-taginput>
  </b-field>
</template>

<script>
export default {
  name: 'agenceTagInput',
  props: {
    value: {
      type: Array,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      search: null,
    };
  },
  computed: {
    selected: {
      get() {
        return this.formatedItems(this.value);
      },
      set(newValue) {
        this.$emit('input', newValue.map(v => v.agenceId));
      },
    },
    filteredItems() {
      return this.items.filter((option) => {
        return !this.alreadySelected(option) && this.searchMatch(option);
      });
    },
  },
  methods: {
    formatedItems(oldItems) {
      if (!Array.isArray(oldItems)) { return []; }
      return this.items.filter(i => oldItems.includes(i.agenceId));
    },
    updateSearch(search) {
      this.search = search;
    },
    alreadySelected(item) {
      return this.selected.map(agence => agence.libelleAgence).includes(item.libelleAgence);
    },
    searchMatch(item) {
      return this.search != null
        ? item.libelleAgence.toString()
          .toLowerCase().indexOf(this.search.toLowerCase())
          >= 0
        : true;
    },
  },
};
</script>

<style>

</style>
